import request from '../../../../util/SuperagentUtils';
import { supplierPendingInventoryActivityReportEndpoints as endpoints } from '../../../../requests/api-endpoints';
import { PendingInventoryActivityVO } from '../../../../types/model/valueObject/pendinginventoryactivity/PendingInventoryActivityVO';

/**
 * Editable fields on a PendingInventoryActivityVO — matches the LIA editability rule.
 * Only fields that map to LocationInventoryActivity are editable.
 */
export interface PendingInventoryActivityPatchPayload {
  bookingNumber?: string;
  containerNumber?: string;
  trailerNumber?: string;
  chassisNumber?: string;
  chassisLicensePlateNumber?: string;
  sealNumber?: string;
  driverFirstName?: string;
  driverLastName?: string;
  driverLicenseNumber?: string;
  truckLicensePlateNumber?: string;
  assetType?: string;
  assetSize?: string;
  scacCode?: string;
  notes?: string;
}

/**
 * Save field corrections to a pending inventory activity (no validation triggered).
 * @param id The pending inventory activity ID
 * @param payload The editable fields to update
 * @returns The updated PendingInventoryActivityVO
 */
export const patchPendingInventoryActivity = (
  id: string,
  payload: PendingInventoryActivityPatchPayload
): Promise<{ body: PendingInventoryActivityVO }> => {
  return request
    .patch(endpoints.actions.update(id))
    .send(payload);
};

/**
 * Resubmit a pending inventory activity for re-validation and processing.
 * On success (validation passes): status becomes RESOLVED, creates real inventory activity.
 * On failure (validation fails): status stays PENDING, error fields are updated.
 * Always returns 200 with the updated record.
 * @param id The pending inventory activity ID
 * @returns The updated PendingInventoryActivityVO
 */
export const resubmitPendingInventoryActivity = (
  id: string
): Promise<{ body: PendingInventoryActivityVO }> => {
  return request
    .post(endpoints.actions.resubmit(id));
};
